import { Components, Theme } from "@mui/material";

export const MuiCard: Components<Theme>["MuiCard"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundImage: "none",
      borderRadius: 16,
      border:
        theme.palette.mode === "dark"
          ? "1px solid rgba(255,255,255,0.06)"
          : "none",
      boxShadow:
        theme.palette.mode === "dark"
          ? "0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.2)"
          : "0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)",
      transition: theme.transitions.create(["box-shadow", "transform"], {
        duration: theme.transitions.duration.standard,
      }),
    }),
  },
};
